export default __webpack_public_path__ + "static/media/app1-1.168d725c.jpg";